import { type FC, useEffect } from 'react';
import type { ICandidateStore } from '../../../stores/JobApplicationStore/CandidateStore';
import { observer } from 'mobx-react';
import { STATE_ERROR, STATE_LOADING } from '../../../stores/state';
import Loader from '../../common/Loader';
import ErrorAlert from '../../common/ErrorAlert';
import PreviousApplicationsDesktop from './Desktop';
import PreviousApplicationsMobile from './Mobile';
import { Text } from 'braid-design-system';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import type { Locale as MelwaysLocale } from '@seek/melways-sites';
import type { TrackStatusUpdateAttributes } from 'src/utils/eventsTypes';

interface Props {
  candidateStore: ICandidateStore;
  isMobile?: boolean;
  locale: MelwaysLocale;
  isVerifiedId: TrackStatusUpdateAttributes['isVerifiedId'];
}

const PreviousApplications: FC<Props> = ({
  candidateStore,
  isMobile = false,
  locale,
  isVerifiedId,
}) => {
  const { t } = useTranslations(translations);
  useEffect(() => {
    candidateStore.loadCandidate({ autoSelectFirstOne: !isMobile });
  }, [candidateStore, isMobile]);

  const { state } = candidateStore;

  if (state === STATE_LOADING) {
    return <Loader />;
  }

  if (state === STATE_ERROR) {
    return (
      <ErrorAlert>
        <Text>{t('Error loading previous applications')}</Text>
      </ErrorAlert>
    );
  }

  return isMobile ? (
    <PreviousApplicationsMobile
      candidateStore={candidateStore}
      locale={locale}
    />
  ) : (
    <PreviousApplicationsDesktop
      candidateStore={candidateStore}
      locale={locale}
      isVerifiedId={isVerifiedId}
    />
  );
};

export default observer(PreviousApplications);
